<template>
  <div>
    <img
      v-if="!localIsRecording"
      @click="startRecording"
      src="@/assets/icons/microphone.svg"
      width="25"
      height="25"
      class="cursor-pointer"
    />

    <div v-else>
      <vue-lottie-player
        class="d-inline-block"
        name="success"
        style="width: 75px; height: 75px"
        :animationData="require('@/assets/animations/recording.json')"
        loop
      />

      <img
        v-if="localIsRecording"
        @click="stopRecording"
        src="@/assets/icons/stop-button.svg"
        width="25"
        height="25"
        class="cursor-pointer"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { UPLOAD_FILE } from "@/store/actions";

import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "ReplyAudio",
  components: { VueLottiePlayer },
  props: {
    isRecording: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localIsRecording: {
      get() {
        return this.isRecording;
      },
      set(value) {
        this.$emit("update:is-recording", value);
      },
    },
  },
  data() {
    return {
      audioURL: null,
      mediaRecorder: null,
      chunks: [],
      devices: [], // Store available devices
      selectedDevice: null, // Store selected device
    };
  },
  mounted() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.log("MediaDevices or getUserMedia not supported");
      // here you could add some user-friendly error handling
    }
    if (!window.MediaRecorder) {
      console.log("MediaRecorder not supported");
      // here you could add some user-friendly error handling
    }
    this.getDevices();
  },
  methods: {
    ...mapActions("files", { uploadFile: UPLOAD_FILE }),
    async getDevices() {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        console.log("Devices", devices);
        this.devices = devices.filter((device) => device.kind === "audioinput");
        this.selectedDevice = this.devices[0];
      } catch (err) {
        console.error("Error getting devices", err);
      }
    },
    async startRecording() {
      if (!this.selectedDevice) {
        console.error("No device selected");
        return;
      }

      try {
        // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId: this.selectedDevice.deviceId,
          },
        });

        this.localIsRecording = true;

        // this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder = new MediaRecorder(stream, { mimeType: "audio/webm;codecs=pcm" });

        this.mediaRecorder.start();

        this.mediaRecorder.ondataavailable = (e) => {
          console.log("e", e);
          this.chunks.push(e.data);
        };

        this.mediaRecorder.onstop = async () => {
          const blob = new Blob(this.chunks, { type: "audio/webm;codecs=pcm" });
          const { key, url } = await this.uploadFile({ type: "messages/audio", file: blob, ext: "webm" });
          this.audioURL = url;
          this.$emit("audio", { audioId: key, url, ext: "webm" });

          this.chunks = [];
        };
      } catch (err) {
        // here you could add some user-friendly error handling
        console.error("Uh oh... unable to get stream...", err);
      }
    },
    stopRecording() {
      if (this.mediaRecorder) {
        this.localIsRecording = false;
        this.mediaRecorder.stop();
      }
    },
    selectDevice(device) {
      this.selectedDevice = device;
    },
  },
};
</script>

<style scoped>
/* Add some styles here to make the component look nice */
</style>
